import {Injectable} from '@angular/core';
import {BaseService, HttpMethod} from './base-service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {WebConfigurationService} from '../web-configuration-module/web-configuration.service';

@Injectable()
export class PricingService extends BaseService {
  constructor(protected http: HttpClient, protected configurationService: WebConfigurationService) {
    super(http, configurationService, 'public/rest/share', configurationService.configuration.ppeApi);
  }
  getSearch(id: string): Observable<any> {
    return this.exec(HttpMethod.get, `/rate/byRef/${id}`,
      this.getSearch, []);
  }

  getPreviousPricingResponse(timestamp): Observable<any> {
    return this.http.get<any>(`https://mpfiles.lenderprice.com/pricing-response-prev.json?timestamp=${timestamp}`);
  }

  getCurrentPricingResponse(timestamp): Observable<any> {
    return this.http.get<any>(`https://mpfiles.lenderprice.com/pricing-response.json?timestamp=${timestamp}`);
  }

  search(search: any): Observable<any> {
    return this.exec(HttpMethod.post, `/rate/search?noSpin`,
      this.search, [search]);
  }

  sendEmail(data: any): Observable<any> {
    return this.exec(HttpMethod.post, `/rate/records`,
      this.sendEmail, [data]);
  }

  getHistoricalPrice(startTime: string, endTime: string): Observable<any> {
    return this.http.get(`${this.configurationService.configuration.mpatApi}public/rest/v1/po/historicalPrice?start=${startTime}&end=${endTime}`);
  }

  getPriceDifference(): Observable<any> {
    return this.http.get(`https://mpat.lenderprice.com/public/rest/v1/po/priceDifference`);
  }

  
}
